<template>
  <div>
    <v-card
    color="red lighten-2"
    dark
  >
    <v-card-title class="headline red lighten-3">
      Search for Public APIs
    </v-card-title>
    <v-card-text>
      Explore hundreds of free API's ready for consumption! For more information visit
      <a
        class="grey--text text--lighten-3"
        href="https://github.com/toddmotto/public-apis"
        target="_blank"
      >the Github repository</a>.
    </v-card-text>
    <v-card-text>
      <v-autocomplete
        v-model="model"
        :items="items"
        :loading="isLoading"
        :search-input.sync="search"
        color="white"
        hide-no-data
        hide-selected
        item-text="Description"
        item-value="API"
        label="Public APIs"
        placeholder="Start typing to Search"
        prepend-icon="mdi-database-search"
        return-object
      ></v-autocomplete>
    </v-card-text>
    <v-divider></v-divider>
    <v-expand-transition>
      <v-list v-if="model" class="red lighten-3">
        <v-list-tile
          v-for="(field, i) in fields"
          :key="i"
        >
          <v-list-tile-content>
            <v-list-tile-title v-text="field.value"></v-list-tile-title>
            <v-list-tile-sub-title v-text="field.key"></v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-expand-transition>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="!model"
        color="grey darken-3"
        @click="model = null"
      >
        Clear
        <v-icon right>mdi-close-circle</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
    <div id="container" style="min-width: 310px; max-width: 800px; height: 400px; margin: 0 auto"></div>
  </div>
</template>

<script>
  import Highcharts from 'highcharts'
  import axios from 'axios'
  import store from '../../store'

  export default {
    data: () => ({
      descriptionLimit: 60,
      entries: [],
      isLoading: false,
      model: null,
      search: null
    }),
    computed: {
      fields () {
        if (!this.model) return []

        return Object.keys(this.model).map(key => {
          return {
            key,
            value: this.model[key] || 'n/a'
          }
        })
      },
      items () {
        return this.entries.map(entry => {
          const Description = entry.tbNome.length > this.descriptionLimit
            ? entry.Description.slice(0, this.descriptionLimit) + '...'
            : entry.Description
          console.log(Object.assign({}, entry, { Description }))
          return Object.assign({}, entry, { Description })
        })
      }
    },
    watch: {
      search (val) {
        // Items have already been loaded
        if (this.items.length > 0) return

        // Items have already been requested
        if (this.isLoading) return

        this.isLoading = true

        // Lazily load input items
        axios.get('http://localhost:8091/my-clinic-new/patient/find', {
          params: {
            patient: val,
            customer: store.state.customer
          }
        }).then(res => {
          const { results } = res.data.results
          this.count = 10
          this.entries = results
        })
          .catch(err => {
            console.error(err)
          })
          .finally(() => (this.isLoading = false))
      }
    },
    methods: {
      teste: () => {
        Highcharts.chart('container', {
          chart: {
            type: 'bar'
          },
          title: {
            text: 'Convênios'
          },
          subtitle: {
            text: 'Source: <a href="https://en.wikipedia.org/wiki/World_population">Clinic</a>'
          },
          xAxis: {
            categories: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio'],
            title: {
              text: null
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: '',
              align: 'high'
            },
            labels: {
              overflow: 'justify'
            }
          },
          tooltip: {
            valueSuffix: ' millions'
          },
          plotOptions: {
            bar: {
              dataLabels: {
                enabled: true
              }
            }
          },
          legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'top',
            x: -40,
            y: 80,
            floating: true,
            borderWidth: 1,
            backgroundColor: ((Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF'),
            shadow: true
          },
          credits: {
            enabled: false
          },
          series: [{
            name: 'Unimed',
            data: [107, 31, 635, 203, 2]
          }, {
            name: 'Particular',
            data: [133, 156, 947, 408, 6]
          }, {
            name: 'Amil',
            data: [814, 841, 3714, 727, 31]
          }, {
            name: 'Clinipam',
            data: [1216, 1001, 4436, 738, 40]
          }]
        })
      }
    },
    mounted () {
      this.teste()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/graph/index.vue